module.exports = __webpack_public_path__ + "static/img/a093.44d00c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a093.jpg
// module id = GuVD
// module chunks = 0